import Cookies from 'js-cookie';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { useStore } from '../core/store';

import { specialCampaignConfig as config } from '../configs/specialCampaignConfig';
import { useBookingDate } from '../hooks/useBookingDate';

export function SpecialCampaignModal() {
  const [showPopup, setShowPopup] = useState(false);
  const { BookingStore } = useStore();
  const booking = BookingStore?.booking?.data;

  const { isSpecialCampaign } = useBookingDate(
    config.dateOffsetStart,
    config.dateOffsetEnd,
  );

  // Check if the booking is a package tour (Pauschalreise)
  const isPackageTour = booking?.serviceName
    ? booking.serviceName.startsWith(config.serviceType)
    : false;

  const handleClose = () => {
    Cookies.set('hideSpecialCampaignModal', true, { expires: 1 }); // expires in 1 day
    setShowPopup(false);
  };

  useEffect(() => {
    if (isSpecialCampaign && !Cookies.get('hideSpecialCampaignModal')) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isSpecialCampaign]);

  return config.arrivalAirport === booking?.flights[0]?.arrivalAirport &&
    isPackageTour ? (
    <div className="overflow-auto">
      <div
        className={classNames(
          'fixed bottom-0 left-0 right-0 flex h-full w-full flex-col items-center text-white overflow-auto bg-brand-1 p-5 md:p-10 transition-transform duration-[2000ms]',
          {
            'visible z-50 translate-y-0 opacity-100': showPopup,
            'invisible -z-[10] translate-y-[50%] opacity-0': !showPopup,
          },
        )}
      >
        <div className="flex w-full justify-end mb-10">
          <span onClick={handleClose} className="icon icon-close text-xl" />
        </div>
        <div className="text-start sm:flex sm:items-center">
          <h2 className="text-xl uppercase">{config.title}</h2>
          <h2 className="text-2xl uppercase font-bold sm:ml-2">
            {config.subTitle}
          </h2>
        </div>
        <img className="my-5 max-h-[300px] w-auto" {...config.image} />
        <div className="md:text-center">
          <p className="my-5">{config.text}</p>
          {config.greeting?.map((line) => (
            <p key={line}>{line}</p>
          ))}
          <p className="my-5 italic text-sm">{config.note}</p>
        </div>
      </div>
    </div>
  ) : null;
}
